import React from "react";
import ReactMarkdown, {Components} from "react-markdown";

interface BotTextMessageProps {
    text?: string
}

export const TextInMarkdown: React.FC<BotTextMessageProps> = ({
                                                                  text
                                                              }) => {

    const components = {
        // @ts-ignore
        a: ({href, children}) => {
            return (
                <a
                    href={href}
                    style={{color: "inherit", textDecoration: "underline"}}
                    onClick={(e) => {
                        e.preventDefault()
                        window.open(href, '_blank', 'noopener,noreferrer')
                    }}
                >
                    {children}
                </a>
            );
        },
        p: ({children}) => {
            return children
        }
    } as Components;

    // Regex to detect bare URLs not already inside Markdown links
    const urlRegex = /(?<!\]\()https?:\/\/[^\s]+/g;

    // Replace plain URLs with a Markdown link: [link](URL)
    const processedMessage = text?.replace(urlRegex, (url) => {
        return `[link](${url})`;
    });

    return <ReactMarkdown components={components}>
        {processedMessage}
    </ReactMarkdown>
}
